import { InternalAxiosRequestConfig } from 'axios';

import { getAuthToken, isTokenExpired } from '../../../utilities/common/token';
import { getDeviceID } from '../../../utilities/common/device';
import { isTokenExchangeRequest } from '../../constants/identity';
import { fetchTokenDataOnExpiry } from './token';
import { getItemFromLocalStorage } from '../../../utilities/common/storage';
import { StorageItems } from '../../constants/app';

const hasExplicitAuthorizationHeader = (
  request: InternalAxiosRequestConfig,
): boolean =>
  typeof request.headers?.has === 'function'
    ? request.headers.has('Authorization')
    : Object.prototype.hasOwnProperty.call(
        request.headers ?? {},
        'Authorization',
      );

const onRequestFulfilled = async (request: InternalAxiosRequestConfig) => {
  console.log('%c Request: ', 'background: #00f; color: #fff', request);

  request.headers.deviceId = getDeviceID();

  if (hasExplicitAuthorizationHeader(request)) {
    return request;
  }

  let authToken = getAuthToken();

  if (authToken && isTokenExpired() && !isTokenExchangeRequest(request.url)) {
    authToken = await fetchTokenDataOnExpiry();
  }

  if (authToken) {
    request.headers.Authorization = authToken;
  }

  const mfaAccessToken = getItemFromLocalStorage(
    StorageItems.ACCESS_TOKEN,
    'string',
  );
  if (mfaAccessToken) {
    request.headers['x-access-token'] = mfaAccessToken;
  }

  return request;
};

const onRequestRejected = (error: Error) => Promise.reject(error);

export { onRequestFulfilled, onRequestRejected };
